import React from 'react';

import Rotation from './Rotation';
import '../../rotation/Rotation.css';

// import * as firebase from 'firebase'
// require("firebase/firestore")
import { getDatabase, update, ref } from "firebase/database";

class RotationContainer extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            champObject: props.champObject,
            idOfRotation: props.idOfRotation,

            rotation: [{ nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }],

            arrayOfTeamsWithScore: [],
            ranking: ['', '', ''],
        }
    }

    componentDidMount = () => {
        // this.componentWillReceiveProps(this.props)

        /* Empty rotations */
        this.setState({
            rotation: [{ nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }]
        })

        let rotation = this.props.rotation;

        if (rotation.competitors !== undefined) {
            let localRotation = [{ nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }]
            for (let i = 0; i < rotation.competitors.length; i++) {
                localRotation[i] = rotation.competitors[i]
            }
            this.setState({ rotation: localRotation })

            if (rotation.competitors[4].hasWon !== undefined) {
                this.buildScore()
            }
        }

        if (rotation.arrayOfTeams !== undefined)
            this.setState({ arrayOfTeamsWithScore: rotation.arrayOfTeams })
    }

    // componentWillReceiveProps = (nextProps) => {
    //     /* Empty rotations */
    //     this.setState({
    //         rotation: [{nome:''},{nome:''},{nome:''},{nome:''},{nome:''},{nome:''}]
    //     })

    //     /* Firestore */
    //     /* Get all rotations */
    //     if(nextProps.idOfRotation !== undefined){
    //         /*firebase.firestore().collection('champs').doc(this.state.champObject.__key).collection('rotation').doc(this.state.idOfRotation.toString()).get()*/
    //         firebase.database().ref('champs/' + nextProps.champObject.__key + '/rotation/' + nextProps.idOfRotation.toString()).once('value')
    //         .then(rotation => {
    //             if(rotation !== undefined && rotation !== null){
    //                 if(rotation.competitors !== undefined){
    //                     let localRotation = [{nome:''},{nome:''},{nome:''},{nome:''},{nome:''},{nome:''}]
    //                     for(let i = 0; i < rotation.competitors.length; i++){
    //                         localRotation[i] = rotation.competitors[i]
    //                     }
    //                     this.setState({ rotation: localRotation })

    //                     if(rotation.competitors[4].hasWon !== undefined){
    //                         this.buildScore()
    //                     }
    //                 }

    //                 if(rotation.arrayOfTeams !== undefined)
    //                     this.setState({ arrayOfTeamsWithScore: rotation.arrayOfTeams })
    //             }
    //         })
    //     }
    // }

    /**
     * Methods to build score of teams and competitor
     */
    buildScore = () => {
        let localArrayOfTeamsScored = [], localArrayOfRanking = ['', '', '']

        let rotation = this.props.rotation;
        let localIndex = 0

        rotation.competitors.forEach(competitor => {
            if (((localIndex === 2 || localIndex === 3) && !competitor.hasWon) || localIndex > 3) {
                localArrayOfTeamsScored.push({ team: competitor.equipe, score: competitor.score })

                /* Create array of ranking */
                if ((localIndex === 2 || localIndex === 3) && !competitor.hasWon)
                    localArrayOfRanking[2] = competitor.nome
                else if (localIndex > 3) {
                    if (competitor.hasWon)
                        localArrayOfRanking[0] = competitor.nome
                    else
                        localArrayOfRanking[1] = competitor.nome
                }
            }
            localIndex++
        })
        this.setState({ ranking: localArrayOfRanking })

        /* Put score in array of team */
        let finalArrayOfTeamScored = []

        for (let j = 0; j < this.state.arrayOfTeamsWithScore.length; j++) {
            finalArrayOfTeamScored.push(this.state.arrayOfTeamsWithScore[j])
            let sumOfScore = 0
            for (let i = 0; i < localArrayOfTeamsScored.length; i++) {
                if (localArrayOfTeamsScored[i].team === this.state.arrayOfTeamsWithScore[j].team) {
                    sumOfScore += localArrayOfTeamsScored[i].score
                }
            }
            finalArrayOfTeamScored[j].score = sumOfScore
        }

        // let localArrayToPush = { arrayOfTeams: finalArrayOfTeamScored }

        /* Put object updated in firebase */
        const db = getDatabase();
        const updates = {};
        updates['champs/' + this.state.champObject.__key + '/rotation/' + this.state.idOfRotation.toString() + '/arrayOfTeams'] = finalArrayOfTeamScored;
        update(ref(db), updates);

        // /* Firestore */
        // /* Get who won in final and semifinals and score them */
        // if (this.state.idOfRotation !== undefined) {
        //     /*firebase.firestore().collection('champs').doc(this.state.champObject.__key).collection('rotation').doc(this.state.idOfRotation.toString()).get()*/
        //     firebase.database().ref('champs/' + this.state.champObject.__key + '/rotation/' + this.state.idOfRotation.toString()).once()
        //         .then(rotation => {
        //             let localIndex = 0
        //             if (rotation !== undefined) {
        //                 rotation.competitors.forEach(competitor => {
        //                     if (((localIndex === 2 || localIndex === 3) && !competitor.hasWon) || localIndex > 3) {
        //                         localArrayOfTeamsScored.push({ team: competitor.equipe, score: competitor.score })

        //                         /* Create array of ranking */
        //                         if ((localIndex === 2 || localIndex === 3) && !competitor.hasWon)
        //                             localArrayOfRanking[2] = competitor.nome
        //                         else if (localIndex > 3) {
        //                             if (competitor.hasWon)
        //                                 localArrayOfRanking[0] = competitor.nome
        //                             else
        //                                 localArrayOfRanking[1] = competitor.nome
        //                         }
        //                     }
        //                     localIndex++
        //                 })
        //                 this.setState({ ranking: localArrayOfRanking })
        //             }
        //         })
        //         .then(() => {
        //             /* Put score in array of team */
        //             let finalArrayOfTeamScored = []

        //             for (let j = 0; j < this.state.arrayOfTeamsWithScore.length; j++) {
        //                 finalArrayOfTeamScored.push(this.state.arrayOfTeamsWithScore[j])
        //                 let sumOfScore = 0
        //                 for (let i = 0; i < localArrayOfTeamsScored.length; i++) {
        //                     if (localArrayOfTeamsScored[i].team === this.state.arrayOfTeamsWithScore[j].team) {
        //                         sumOfScore += localArrayOfTeamsScored[i].score
        //                     }
        //                 }
        //                 finalArrayOfTeamScored[j].score = sumOfScore
        //             }

        //             let localArrayToPush = { arrayOfTeams: finalArrayOfTeamScored }

        //             /* Firestore */
        //             /* Put object updated in firebase */
        //             /*firebase.firestore().collection('champs').doc(this.state.champObject.__key).collection('rotation').doc(this.state.idOfRotation.toString())*/
        //             firebase.database().ref('champs/' + this.state.champObject.__key + '/rotation/' + this.state.idOfRotation.toString())
        //                 .update(localArrayToPush)
        //         })
        // }
    }

    render() {

        return (
            <Rotation
                rotation={this.state.rotation}
                isScoreMan={false}
                isCoord={false}
                idOfRotation={this.state.idOfRotation}
                ranking={this.state.ranking}
                arrayOfTeamsWithScore={this.state.arrayOfTeamsWithScore}

            />
        )
    }
}

export default RotationContainer